import { parseDate } from '@internationalized/date';
import type { DateValue } from 'react-aria-components';

export function toDateValue(raw: string): DateValue | null {
  if (raw === '') return null;
  try {
    return parseDate(raw);
  } catch {
    return null;
  }
}
